package es.subastia.auctionlist

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import es.subastia.domain.model.AuctionProcedureType
import es.subastia.domain.usecase.GetUserPreferencesUseCase
import es.subastia.domain.usecase.SaveUserPreferencesUseCase
import es.subastia.ui.mapper.toDomain
import es.subastia.ui.mapper.toUi
import es.subastia.ui.model.AuctionTypeUiModel
import es.subastia.ui.model.ProvinceUiModel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.launch

data class AuctionFilterUiState(
    val selectedType: AuctionTypeUiModel? = null,
    val selectedProcedureType: AuctionProcedureType? = null,
    val selectedProvince: ProvinceUiModel? = null,
)

class AuctionFilterViewModel(
    private val getUserPreferencesUseCase: GetUserPreferencesUseCase,
    private val saveUserPreferencesUseCase: SaveUserPreferencesUseCase,
) : ViewModel() {

    private val _state = MutableStateFlow(AuctionFilterUiState())
    val state: StateFlow<AuctionFilterUiState> = _state.asStateFlow()

    init {
        viewModelScope.launch {
            val type = getUserPreferencesUseCase.getSavedType().first()?.toUi()
            val procedureType = getUserPreferencesUseCase.getSavedProcedureType().first()
            val province = getUserPreferencesUseCase.getSavedProvince().first()?.toUi()
            _state.value = AuctionFilterUiState(
                selectedType = type,
                selectedProcedureType = procedureType,
                selectedProvince = province,
            )
        }
    }

    fun selectType(type: AuctionTypeUiModel?) {
        _state.value = _state.value.copy(selectedType = type)
    }

    fun selectProvince(province: ProvinceUiModel?) {
        _state.value = _state.value.copy(selectedProvince = province)
    }

    fun selectProcedureType(type: AuctionProcedureType?) {
        _state.value = _state.value.copy(selectedProcedureType = type)
    }

    fun saveFilters() {
        viewModelScope.launch {
            val currentState = _state.value
            saveUserPreferencesUseCase.saveType(currentState.selectedType?.toDomain())
            saveUserPreferencesUseCase.saveProcedureType(currentState.selectedProcedureType)
            saveUserPreferencesUseCase.saveProvince(currentState.selectedProvince?.toDomain())
        }
    }
}
